import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import GlobalStyles from "../../global/GlobalStyles";
import logo from "../../logo.png";
import api from "../../global/api";
import ShippingDetailsCard from "../../components/others/ShippingDetailsCard";
import { FaSearch } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import SmallLoader from "../../components/loaders/SmallLoader";

const OrderPage = () => {
  const { tracking_id } = useParams();
  const [shippingPackage, setShippingPackage] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const getShippingPackage = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/track/${tracking_id}`);
      setShippingPackage(response.data);
    } catch (error) {
      setShippingPackage(null); // Ensure it's null on error
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getShippingPackage();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="w-full h-screen bg-default2 bg-center bg-cover">
      <div className="w-full h-full bg-black/70 flex flex-col justify-center items-center gap-10 pt-16">
        {loading ? (
          <SmallLoader />
        ) : (
          <div className="w-5/6 md:w-1/2 lg:w-1/3">
            {!shippingPackage ? (
              <div className={GlobalStyles.sectionWrap}>
                <div className="w-full flex flex-col items-center gap-5 p-6">
                  <div className="flex items-center gap-3">
                    <img src={logo} alt="" className="h-10" />
                    <h2 className={`${GlobalStyles.formHeader} text-primary`}>
                      Tracking Not Found
                    </h2>
                  </div>

                  <div className="relative w-24 h-24 rounded-full bg-primary/10 flex justify-center items-center my-4">
                    <MdClose className="absolute top-1 right-1 text-xl text-primary" />
                    <FaSearch className="text-4xl text-primary" />
                  </div>

                  <div className="text-center">
                    <p className={`${GlobalStyles.textSecondary} mb-3`}>
                      We couldn't find any shipment with tracking ID:
                    </p>
                    <p className="font-mono bg-primary/10 px-3 py-2 rounded text-primary text-sm">
                      {tracking_id}
                    </p>
                    <p className={`${GlobalStyles.textSecondary} mt-4`}>
                      Please verify the tracking number and try again.
                    </p>
                    <p className={`${GlobalStyles.textSecondary} mt-2`}>
                      If you believe this is an error, please contact our
                      support team.
                    </p>
                  </div>

                  <div className="flex gap-4 w-full">
                    <button
                      className={`${GlobalStyles.buttonFullAlt}`}
                      onClick={() => navigate(-1)}
                    >
                      Go Back
                    </button>
                    <button
                      className={`${GlobalStyles.buttonFull}`}
                      onClick={() => navigate("/support")}
                    >
                      Contact Support
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <ShippingDetailsCard shippingPackage={shippingPackage} />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderPage;
